import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=05b565f6&scoped=true&"
import script from "./GroupList.vue?vue&type=script&lang=ts&"
export * from "./GroupList.vue?vue&type=script&lang=ts&"
import style0 from "./GroupList.vue?vue&type=style&index=0&id=05b565f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b565f6",
  null
  
)

export default component.exports